import { Link } from 'react-router-dom'
import {Facebook, Instagram, Linkedin, Twitter, MapPin, Phone, Mail} from 'lucide-react'
import Container from '@/components/ui/Container'
import NewsletterForm from '@/components/NewsletterForm'
import { WhatsAppIcon, WHATSAPP_URL } from '@/components/WhatsAppButton'
import { useLanguage } from '@/context/LanguageContext'

const footerLinks = [
  {
    title: 'Empresa',
    links: [
      { label: 'Sobre Nós', to: '/sobre' },
      { label: 'Carreiras', to: '/carreiras' },
      { label: 'Blog', to: '/blog' },
      { label: 'Eventos', to: '/eventos' },
    ],
  },
  {
    title: 'Soluções',
    links: [
      { label: 'Videovigilância', to: '/servicos/videovigilancia' },
      { label: 'Alarmes de Intrusão', to: '/servicos/alarmes-intrusao' },
      { label: 'Alarme de Incêndio', to: '/servicos/alarme-incendio' },
      { label: 'Controle de Acesso', to: '/servicos/controle-acesso' },
      { label: 'Redes e Telecom', to: '/servicos/redes-telecom' },
    ],
  },
  {
    title: 'Recursos',
    links: [
      { label: 'Centro de Downloads', to: '/recursos' },
      { label: 'Solicitar Consultoria', to: '/contato' },
    ],
  },
]

function Footer() {
  const { t } = useLanguage()

  return (
    <footer className="bg-slate-900 text-slate-300">
      <Container className="py-14">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2">
              <img
                src="https://static.lumi.new/1f/1ff5ae783ff7274a593125c064bf26df.webp"
                alt="FRM Soluções"
                className="h-16 w-auto invert mix-blend-screen"
              />
            </Link>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-slate-400">
              Consultoria especializada em videovigilância, alarmes, controle de acesso, redes e telecom para empresas que exigem segurança de nível corporativo.
            </p>
            <div className="mt-6 space-y-2 text-sm text-slate-400">
              <p className="flex items-center gap-2"><MapPin className="h-4 w-4 shrink-0 text-cyan-400" aria-hidden="true" /> Avenida Carlos Meziano, 482, Portuguesa, Rio de Janeiro, RJ</p>
              <p className="flex items-center gap-2"><Phone className="h-4 w-4 shrink-0 text-cyan-400" aria-hidden="true" /> (21) 97226-5440</p>
              <p className="flex items-center gap-2"><Mail className="h-4 w-4 shrink-0 text-cyan-400" aria-hidden="true" /> comercial@frm.net.br</p>
            </div>
            <div className="mt-6 flex items-center gap-3">
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Conversar no WhatsApp"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-[#25D366] text-white transition-colors hover:bg-[#1ebe5d]"
              >
                <WhatsAppIcon className="h-4 w-4" />
              </a>
              <a
                href="https://www.instagram.com/frmsolucoes"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram @frmsolucoes"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-white/5 text-slate-300 transition-colors hover:bg-cyan-600 hover:text-white"
              >
                <Instagram className="h-4 w-4" aria-hidden="true" />
              </a>
              {[Facebook, Linkedin, Twitter].map((Icon, idx) => (
                <a
                  key={idx}
                  href="#"
                  aria-label="Rede social"
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-white/5 text-slate-300 transition-colors hover:bg-cyan-600 hover:text-white"
                >
                  <Icon className="h-4 w-4" aria-hidden="true" />
                </a>
              ))}
            </div>
          </div>

          {footerLinks.map(group => (
            <div key={group.title}>
              <h3 className="text-sm font-semibold text-white">{group.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {group.links.map(link => (
                  <li key={link.to}>
                    <Link to={link.to} className="text-sm text-slate-400 transition-colors hover:text-cyan-400">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-white/10 pt-8 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <p className="text-sm font-semibold text-white">{t('newsletter.title')}</p>
            <p className="text-xs text-slate-500">Novidades do setor e conteúdos exclusivos, direto no seu e-mail.</p>
          </div>
          <NewsletterForm />
        </div>

        <div className="mt-8 flex flex-col gap-3 border-t border-white/10 pt-6 text-xs text-slate-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} Site Consultoria Tech. {t('footer.rights')}</p>
          <Link to="/privacidade" className="hover:text-cyan-400">{t('footer.privacy')}</Link>
        </div>
      </Container>
    </footer>
  )
}

export default Footer
